<template>
  <!-- Kontener strony logowania -->
  <div :class="['container', { 'container--sg': shouldHideLocation }]">
    <div class="card m-3 text-center">
      <!-- Nagłówek formularza logowania -->
      <h4 class="card-header">{{ t('log-in') }}</h4>
      <div class="d-flex card-body justify-content-center">
        <!-- Formularz logowania z walidacją -->
        <Form
          @submit="onSubmit"
          :validation-schema="schema"
          v-slot="{ errors, isSubmitting }"
        >
          <!-- Pole loginu -->
          <div class="form-group row mb-1">
            <label class="col-sm-2 col-form-label">{{ t('login') }}</label>
            <div class="col-sm-10">
              <Field
                name="username"
                type="text"
                class="form-control"
                :class="{ 'is-invalid': errors.username }"
              />
              <div class="invalid-feedback">{{ errors.username }}</div>
            </div>
          </div>
          <!-- Pole hasła -->
          <div class="form-group row mb-1">
            <label class="col-sm-2 col-form-label">{{ t('password') }}</label>
            <div class="col-sm-10">
              <Field
                name="password"
                type="password"
                class="form-control"
                :class="{ 'is-invalid': errors.password }"
              />
              <div class="invalid-feedback">{{ errors.password }}</div>
            </div>
          </div>
          <!-- Link do resetu hasła, przycisk logowania, link do starego systemu -->
          <div class="form-group row d-flex flex-column align-items-center">
            <div class="col-auto">
              <router-link to="reset-password" class="btn btn-link">
                {{ t('forgot-password') }}
              </router-link>
            </div>
            <div class="col-auto">
              <button class="btn btn-outline-secondary" :disabled="isSubmitting">
                <span
                  v-show="isSubmitting"
                  class="spinner-border spinner-border-sm mr-1"
                ></span>
                {{ t('log-in').toUpperCase() }}
              </button>
            </div>
<!--            <div class="col-auto">-->
<!--              <a-->
<!--                :href="legacyBaseUrl"-->
<!--                target="_blank"-->
<!--                rel="noopener"-->
<!--                class="btn btn-outline-dark mt-2"-->
<!--              >-->
<!--                {{ t('go-to-old-system') }}-->
<!--              </a>-->
<!--            </div>-->
<!--            <br>-->
<!--            <div class="col-auto">-->
<!--              <p>-->
<!--                <b style="color: red; font-size: 15px;">-->
<!--                  {{ t('end-of-old-system') }}-->
<!--                </b>-->
<!--              </p>-->
<!--            </div>-->
          </div>
          <!-- Komunikat o błędzie logowania -->
          <div
            v-if="errorStore.errorMessage"
            class="alert alert-danger alert-dismissible fade show"
            role="alert"
          >
            {{ errorStore.errorMessage }}
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Form, Field } from 'vee-validate';
import * as Yup from "yup";
import { useAuthStore } from "@/stores/auth.store";
import { useErrorStore } from "@/stores/error.store";
import { useI18n } from 'vue-i18n';
import { computed } from 'vue'

const { t } = useI18n(); // tłumaczenia

const errorStore = useErrorStore(); // globalny store na błędy

// Schemat walidacji logowania (z tłumaczeniem błędów)
const schema = Yup.object().shape({
  username: Yup.string().required(t('user-login-required')),
  password: Yup.string().required(t('user-password-required')),
});

const authStore = useAuthStore();

// Obsługa submitu formularza
async function onSubmit(values) {
  const { username, password } = values;
  await authStore.login(username, password);
}

// Link do starego systemu
// const legacyBaseUrl = (process.env.VUE_APP_API_URL || "").slice(0, -7);

const shouldHideLocation = computed(() => {
      const version = process.env.VUE_APP_VERSION_NAME || "";
      return version.startsWith("SG");
    });
</script>

<style scoped>
/* Kontener z tłem oraz responsywnym środkiem */
.container {
  background-image: url("../assets/login.jpg"); /* obrazek w tle */
  height: 1200px;
  width: 1300px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 150px;
  position: relative;
}

.container--sg {
  background-image: url("../assets/sglogin.jpg"); /* obrazek w tle dla wersji SG */
}

/* Półprzezroczysta warstwa nakładki dla lepszej czytelności formularza */
.container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(241, 241, 241, 0.5);
  z-index: 1;
}

/* Zawartość na wierzchu nakładki */
.container > * {
  position: relative;
  z-index: 2;
}

.card {
  width: 500px;
}

.card-body {
  background: #f5f4f3;
}

.card-body form {
  width: 400px;
}

.col-form-label {
  text-align: right;
  line-height: 25px;
}

/* Stylowanie przycisków i linków */
button {
  border: 0;
  color: #231f20;
  font-size: 15px;
  font-weight: bold;
}
a {
  color: #231f20;
  font-size: 12px;
  text-decoration: none;
}

/* Pola input */
input {
  border: 0;
  border-left: 1px solid #c8c7c7;
  border-top: 1px solid #c8c7c7;
  padding: 10px;
}
input:focus {
  border-color: #c8c7c7;
  box-shadow: 0 0 0 0.25rem rgba(100, 101, 104, 0.25);
}

.alert-danger {
  margin-top: 1rem;
}
</style>
